// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1shfg","modalFooterButton":"ModalNotes_modalFooterButton__15a3o"};